// ============================================================
// Platform detection — capabilities & environment
// ============================================================
import type { PlatformCapabilities } from '../core/types';

export function detectPlatform(): PlatformCapabilities {
  const ua = navigator.userAgent.toLowerCase();

  const isIOS = /iphone|ipad|ipod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const isAndroid = /android/.test(ua);
  const isMobile = isIOS || isAndroid;
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  let isMSE = false;
  try {
    isMSE = typeof MediaSource !== 'undefined' && typeof MediaSource.isTypeSupported === 'function';
  } catch { /* */ }

  let isNativeHLS = false;
  try {
    const video = document.createElement('video');
    isNativeHLS = !!video.canPlayType('application/vnd.apple.mpegURL');
  } catch { /* */ }

  const supportsFullscreen = !!(
    document.fullscreenEnabled ||
    (document as any).webkitFullscreenEnabled ||
    (document as any).mozFullScreenEnabled ||
    (document as any).msFullscreenEnabled
  );

  const supportsPiP = 'pictureInPictureEnabled' in document;

  let browser: PlatformCapabilities['browser'] = 'other';
  if (/edg\//.test(ua)) browser = 'edge';
  else if (/chrome|chromium|crios/.test(ua)) browser = 'chrome';
  else if (/firefox|fxios/.test(ua)) browser = 'firefox';
  else if (/safari/.test(ua) && !/chrome/.test(ua)) browser = 'safari';

  return {
    isMobile,
    isIOS,
    isAndroid,
    isTouch,
    isMSE,
    isNativeHLS,
    supportsFullscreen,
    supportsPiP,
    browser,
  };
}
